import { Check, X, Sparkles } from "lucide-react";

export default function AdminFractionalTab({ pendingOfferings, onApprove, onReject }) {
  return (
    <div className="zc-card overflow-hidden overflow-x-auto mt-4" data-testid="admin-pending-fractional">
      {pendingOfferings.length === 0 && <div className="px-4 sm:px-6 py-10 text-center text-[var(--zc-text-3)] text-sm">No pending fractional offerings.</div>}
      {pendingOfferings.map(o => {
        const v = o.vehicle_snapshot || {};
        const totalRaise = (o.total_fractions || 0) * (o.price_per_fraction || 0);
        return (
          <div key={o.offering_id} className="flex flex-col gap-3 sm:grid sm:grid-cols-[80px,1fr,auto] sm:items-center px-4 sm:px-6 py-4 border-b border-[var(--zc-border)] last:border-0">
            {v.image ? <img src={v.image} className="w-20 h-14 object-cover rounded shrink-0" alt="" /> : <div className="w-20 h-14 bg-[var(--zc-bg-3)] rounded grid place-items-center shrink-0"><Sparkles size={18} className="text-[var(--zc-text-3)]" /></div>}
            <div className="min-w-0">
              <div className="zc-title text-lg">{v.year} {v.make} {v.model}</div>
              <div className="text-xs text-[var(--zc-text-3)]">
                {o.total_fractions?.toLocaleString()} fractions × ${o.price_per_fraction} = <b className="text-[var(--zc-text)]">${totalRaise.toLocaleString()}</b> raise · by {o.owner_name || "host"}
              </div>
            </div>
            <div className="flex flex-wrap gap-2 zc-stack-actions">
              <button onClick={() => onApprove(o.offering_id)} className="px-3 h-9 zc-btn-primary text-xs flex items-center gap-1" data-testid={`fapprove-${o.offering_id}`}>
                <Check size={12} /> Approve
              </button>
              <button onClick={() => onReject(o.offering_id)} className="px-3 h-9 zc-btn-ghost text-xs flex items-center gap-1" data-testid={`freject-${o.offering_id}`}>
                <X size={12} /> Reject
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
